<template>
  <div
    id="in-page-navigation"
    class="layout/anchor-offset"
    v-if="hasAnchorIds"
    >
    <ul
      class="
        layout/grid:1
        layout/width:100%
        layout/grid:gap:row:baseline
        layout/justify:start
      "
      >
      <li
        v-for="(anchorId, index) in anchorIds"
        :key="index"
        >
        <a
          :href="`#${anchorId}`"
          role="button"
          class="
            link/focus
          "
        >
        <p
          class="
            typography
            "
            v-html="svgContent(anchorTitles[index])"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';

  export default {
    props: {
      anchorIds: { type: Array, required: true },
      anchorTitles: { type: Array, required: true }
    },
    computed: {
      hasAnchorIds(){
        return this.anchorIds.length > 0;
      },
    },
    methods: {
      svgContent(str) {
        console.log(str)
        return addSvgToEnd(str, "layout/block", "icon__arrow--16--stroke.svg", 'typography/icon:after:90deg');
      },
    }
  };
</script>
